import { useMediaQuery, useTheme } from '@mui/material'

import { NavbarDesktop } from './navbar-desktop.component'
import { NavbarMobile } from './navbar-mobile.component'

import { INavBarData } from 'src/types'

interface INavbarProps {
  navbarData: INavBarData[]
}

const Navbar = ({ navbarData }: INavbarProps) => {
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('laptop'))

  return isDesktop ? (
    <NavbarDesktop navbarData={navbarData} />
  ) : (
    <NavbarMobile navbarData={navbarData} />
  )
}

export { Navbar }
